const $ = jQuery.noConflict()

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  // console.log("COMMAND EXECUTED", player, command)
  if (player == null || command == null) return;

  // console.log("COMMAND EXECUTED", player, command)
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}
 
var $countSub;
var self = module.exports = {
  widths: [0, 575, 767, 1023, 1279, 1599],

  init: function(selector) {
    $(selector).each(function() {
      self.service.init(this, $(this).attr('slick-type'))
    })
  },

  service: {
    init: function(slider, slickType) {
      var settings = {
        infinite: true,
        pauseOnHover: false,
        swipeToSlide: true,
        touchMove: true,
        swipe: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: 'slick__dots',
        nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
        prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
        mobileFirst: true
      };
      if(slickType == 'no-infinite-full-width'){
          settings = {
          infinite: false,
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4.4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3.4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll:1
              }
            },
            {
              breakpoint: 0,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll:1
              }
            }
          ]
        };
      }
      if(slickType == 'pagelinks-no-infinite-full-width'){
          settings = {
          infinite: false,
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3.1,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll:1
              }
            },
            {
              breakpoint: 0,
              settings: {
                slidesToShow: 1.1,
                slidesToScroll:1
              }
            }
          ]
        };
      } 
      if(slickType == 'news-no-infinite-full-width'){
          settings = {
          infinite: false,
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 2.3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll:1
              }
            },
            {
              breakpoint: 0,
              settings: {
                slidesToShow: 1.2,
                slidesToScroll:1
              }
            }
          ]
        };
      }
      if(slickType == 'reviews-slider-for'){
          settings = {
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.slider-nav',
          draggable: false,
          infinite: false,
        };
      }
      if(slickType == 'reviews-slider-nav'){
          var $slider1 = $('.slider-nav');
          $slider1.on('init', function(event, slick, currentSlide, nextSlide){
              $countSub = slick.slideCount / 2;
              $countSub = Math.round($countSub);
              $slider1.attr("nav-items", $countSub);
          });

          settings = {
          dotsClass: 'slick__dots',
          nextArrow: '<button type="button" class="slick__next"><i class="fas fa-fw fa-angle-right"></i></button>',
          prevArrow: '<button type="button" class="slick__prev"><i class="fas fa-fw fa-angle-left"></i></button>',
          centerMode: true,
          asNavFor: '.slider-for',
          focusOnSelect: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          //initialSlide: 2,
          variableWidth: true,
        };
      }


      var calculate_height = function() {
        var rat1 = 16; var rat2 = 9;
        var ratio  = $(window).width() / rat1;
        var calculated_height = ratio * rat2;
        //$('.hero-large').css('height', calculated_height)
      };
      if($(slider).data('slidertype') == 'video') {
        $(window).resize(calculate_height)
        calculate_height();
      }

      var data = Object.entries($(slider).data())

      for (var i = 0; i < data.length; i++) {
        data[i] = self.service.processData(data[i][0], data[i][1])
      }

      for (var i = 0; i < data.length; i++) {
        settings[data[i][0]] = data[i][1]
      }

      $(slider).on('init', function ( slick, currentSlide) {
        slick = $(slick.currentTarget);
        setTimeout(function(){
          self.service.playVideo(slick, "play");
        }, 1000);
      })

      $(slider).on('afterChange', function (event, slick, currentSlide) {
        slick = $(slick.$slider);
        //playPauseVideo(slick,"play");
      })

      $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var slide = $(slick.$slides.get(currentSlide))
        var next = $(slick.$slides.get(nextSlide))
        var counter = $(slider).data('counter')
        self.service.stopVideo($(slide))

        if (counter) {
          var count = $(next).data('count')
          $(counter).text(count)
        }
      })

      $(slider).slick(settings)

      if (settings.autoplay === true) {
        // slick($(slider), 'Next')
        // slick($(slider), 'slickPlay')
      }
    },

    playVideo: function(slide) {
      player = slide.find("iframe").get(0);
      postMessageToPlayer(player, {
        "event": "command",
        "func": "mute"
      });
      postMessageToPlayer(player, {
        "event": "command",
        "func": "playVideo"
      });
    },

    stopVideo: function(slide) {
      player = slide.find("iframe").get(0);
      postMessageToPlayer(player, {
        "event": "command",
        "func": "pauseVideo"
      });
    },

    processData: function(label, value) {
      switch (label) {
        case 'responsive':
          var max = self.widths.length
          var responsive = []

          for (var i = 0; i < max; i++) {
            var rule = {
              breakpoint: self.widths[i],
              settings: {
                slidesToShow: value[i]
              }
            }

            responsive.push(rule);
          }
          return [label, responsive]
          break;
        case 'autospeed':
          return ['autoplaySpeed', value]
          break;
        case 'nav':
          return ['asNavFor', value]
          break;
        default:
          return [label, value]
      }
    }
  }
}
setTimeout(function(){
 var $count = $('.slider-nav').attr("nav-items");
 $('.slider-nav').slick('slickGoTo', $count - 1, true);
}, 3000);

